import React from 'react'
import cx from 'classnames'
import { currencyUtils } from 'utils/index'
import Button from '../../../../views/components/atoms/Button/Button'
import CalendarIcon from '../../../../views/components/atoms/Icons/Controls/Calendar'
import { getCommissionWalletNotice } from './trustAccountsUtils'
import styles from './TrustAccounts.module.scss'

const { formatCurrency } = currencyUtils

interface TrustAccountsProps {
  className?: string
  /** All balances are in cents. */
  transactionalBalance: number
  depositBalance: number
  commissionBalance: number
  bankName?: string
  accountNumber?: string
  /** Only account owners may withdraw from the commission wallet. */
  canWithdraw: boolean
  viewStatementDisabled?: boolean
  onViewStatement: () => void
  onWithdraw: () => void
}

const TrustAccounts = ({
  className,
  transactionalBalance,
  depositBalance,
  commissionBalance,
  bankName,
  accountNumber,
  canWithdraw,
  viewStatementDisabled,
  onViewStatement,
  onWithdraw,
}: TrustAccountsProps) => {
  const isWalletFunded = commissionBalance > 0

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.account}>
        <div className={styles.row}>
          <div>
            <h4 className={styles.title}>Transactional Account</h4>
            <strong className={styles.amount}>{formatCurrency(transactionalBalance)}</strong>
          </div>
          <Button disabled={viewStatementDisabled} onClick={onViewStatement}>
            View statement
          </Button>
        </div>

        <div className={styles.wallet}>
          <div className={styles.row}>
            <div>
              <p className={styles['wallet-title']}>Of which, commission wallet</p>
              <strong className={cx(styles['wallet-amount'], { [styles['is-empty']]: !isWalletFunded })}>
                {formatCurrency(isWalletFunded ? commissionBalance : 0)}
              </strong>
              <p className={styles.notice}>
                <CalendarIcon width={16} height={16} viewBox="4 4 24 24" />
                {getCommissionWalletNotice({ balance: commissionBalance, bankName, accountNumber })}
              </p>
            </div>
            {canWithdraw && isWalletFunded && <Button onClick={onWithdraw}>Withdraw now</Button>}
          </div>
        </div>
      </div>

      <div className={styles.account}>
        <h4 className={styles.title}>Deposit Account</h4>
        <strong className={styles.amount}>{formatCurrency(depositBalance)}</strong>
      </div>
    </div>
  )
}

export default TrustAccounts
